import { LF_MEMBERSHIP_SKU } from "@lib/productCatalog"
import { Cart } from '@framework/types/cart'

export const isPurchasingLFMembership = (
  cartData: Cart,
): boolean => {
  return !!cartData?.lineItems?.find(item => item.variant.sku === LF_MEMBERSHIP_SKU)
}
